import { addDays } from './panel';

/** Ofertele, cu atâtea zile înainte de ziua în care materialul trebuie pe șantier. */
export const DEADLINE_BEFORE_NEEDED = 3;

/**
 * Termenul de răspuns propus la o cerere nouă: o săptămână, dar cu
 * `DEADLINE_BEFORE_NEEDED` zile înainte de ziua de pe șantier, ca să rămână timp
 * de comandă și livrare. Niciodată mai devreme de mâine. 'AAAA-LL-ZZ'.
 */
export function defaultDeadline(today: string, neededBy: string | null | undefined): string {
  const week = addDays(today, 7);
  if (!neededBy) return week;
  const before = addDays(neededBy, -DEADLINE_BEFORE_NEEDED);
  const tomorrow = addDays(today, 1);
  const pick = before < week ? before : week;
  return pick < tomorrow ? tomorrow : pick;
}
